/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { Message } from 'CalltakingCoreApi';

export class HistoricalTextMessage {
    public static toMessage(textMessage: HistoricalTextMessage): Message {
        return {
            uuid: textMessage.uuid,
            callId: textMessage.ctcCallId,
            agencyId: textMessage.agencyId,
            type: 'SMS',
            message: textMessage.messageBody,
            privy: false,
            createdTimestamp: textMessage.dateTime,
            updatedTimestamp: textMessage.dateTime,
            sender: textMessage.userName ? textMessage.userName : textMessage.callingNumber,
            senderParticipantId: '',
            messageSenderType: 'AGENT',
            predefined: false,
            predefinedLanguage: '',
            targetedUsers: []
        } as Message;
    }

    uuid: string;
    agencyId: string;
    callingNumber: string;
    messageBody: string;
    dateTime: string;
    ctcCallId: string;
    userName: string;
}
